import { RISK_STATISTIC_SETTINGS } from '../../constants/business/risk';
import { getDashboardHighestStatus, getDashboardStatusBySteps } from './dashboard';

const getStatisticStatus = {
    residualOutsideOfRiskAppetite(percentage: number | null) {
        return getDashboardStatusBySteps(
            percentage,
            RISK_STATISTIC_SETTINGS.RESIDUAL_OUTSIDE_OF_RISK_APPETITE_PERCENTAGE_STEPS,
        );
    },

    withoutControl(count: number | null) {
        return getDashboardStatusBySteps(count, RISK_STATISTIC_SETTINGS.WITHOUT_CONTROL_COUNT_STEPS);
    },

    overdueActionsPercentage(percentage: number | null) {
        return getDashboardStatusBySteps(percentage, RISK_STATISTIC_SETTINGS.OVERDUE_ACTIONS_PERCENTAGE_STEPS);
    },

    getGeneral({
        residualOutsideOfRiskAppetitePercentage,
        withoutControlsCount,
        overdueActionsPercentage,
    }: {
        residualOutsideOfRiskAppetitePercentage: number | null;
        withoutControlsCount: number | null;
        overdueActionsPercentage: number | null;
    }) {
        const statuses = [
            this.residualOutsideOfRiskAppetite(residualOutsideOfRiskAppetitePercentage),
            this.withoutControl(withoutControlsCount),
            this.overdueActionsPercentage(overdueActionsPercentage),
        ];

        return getDashboardHighestStatus(statuses);
    },
};

export const RiskUtils = {
    getStatisticStatus,
};
